// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

// Note the singular `friend/` — `friends` is the friend-list screen. This route has no dynamic
// segment because the invite token rides in the URL fragment, which never reaches a server.
export { default } from '@/features/friend-invite/FriendInviteScreen';
